import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const calenderSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor"
              d="M5.5 13v-2.5m8.5 11h6.5a2 2 0 0 0 2-2v-9m-17 0v-2c0-1.1.9-2 2-2h13a2 2 0 0 1 2 2v2m-17 0h17"></path>
        <path fill="currentColor" d="M10 4h1v4h-1V4zM17 4h1v4h-1V4z"></path>
        <path stroke="currentColor" d="M4 18.5h7.5m0 0L8 22m3.5-3.5L8 15"></path>
    </svg>
)

const Calender: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {calenderSvg}
    </SvgIcon>
)

export default Calender